import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#EBEBEB",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M15.548 3.016c-7 0-12.69 5.69-12.69 12.678 0 6.99 5.69 12.685 12.69 12.685h17.08c6.99 0 12.69-5.69 12.69-12.69C45.317 8.7 39.627 3 32.627 3h-17.08z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#E31F28",
  d: "m35.615 14.923 5.68 6.762a10.438 10.438 0 0 0 1.863-5.985c0-2.34-.766-4.51-2.07-6.26zM19.514 8.86c4.24 0 7.44 1.083 7.771 4.655l4.463-4.654h8.894c-1.941-2.268-4.804-3.707-8.009-3.707H15.548c-3.204 0-6.083 1.44-8.009 3.707h11.975Zm-6.984 4.51-1.517 4.163h6.114c1.802 0 2.356-.751 2.76-2.19.403-1.43-.606-1.973-1.838-1.973zm19.259 8.879-4.722-5.964c-.875 4.069-3.733 5.964-9.091 5.964H7.296a10.52 10.52 0 0 0 8.252 3.981h17.08c3.339 0 6.31-1.563 8.242-3.981z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }